import { IonSpinner, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { logoYoutube, heartCircle, chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import ActionComp from '../components/ActionComp'; 
import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

  
const VidFileContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const router = useIonRouter();

    // click on content
    const showContent = async () => {
        if (content.locked < 1 && view == "def")
        {
            // for long text show in normal mode, for short text, show in video mode
            let videoMode = false;
            if (content.desc.length < 100)
                videoMode = true;
            if (content.sponsored)
                videoMode = false;

            let ready = await ReadyAds();
            
            if (videoMode)
            {
                if (!ready)
                    router.push("/video/" + content.id + "/n", "forward", "push");
                else
                {
                    ShowAds( () => {
                        router.push("/video/" + content.id + "/ad", "forward", "push");
                    });
                }
            }
            else
            {
                if (!ready)
                    router.push("/content/" + content.id + "/n", "forward", "push");
                else
                {
                    ShowAds( () => {
                        router.push("/content/" + content.id + "/ad", "forward", "push");
                    });
                }
            }
        }
    }

    return (
        <div className="video-content">
            <UserBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
            <div className="lock-wrapper" onClick={showContent}>    
                {
                    /* for content locked */
                    content.locked > 1 ?
                <div className="video-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heartCircle} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_SUPERLIKE_TO_UNLOCK) }
                </div>
                    :
                    content.locked == 1 ?
                <div className="video-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heart} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_LIKE_TO_UNLOCK) }
                </div>
                    :
                <div/>
                }
                
                {
                    view == "video" ?
                <div className="fullscreen-video-wrapper">
                    {
                        content.images.length > 0 ?
                    <video className="fullscreen-video-player" key={content.id} loop={true} autoPlay controls>
                        <source src={ content.images[0] } />
                        Your browser does not support the video tag.
                    </video>
                        :
                    <div className="fullscreen-video-error">
                        <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                    </div>
                    }
                </div>
                    :
                    view == "full" ?
                <div>
                    {
                        content.images.length > 0 ?
                    <video className="html-video-player" loop={false} autoPlay controls>
                        <source src={ content.images[0] } />
                        Your browser does not support the video tag.
                    </video>
                        :
                    <div className="video-error-view">
                        <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                    </div>
                    }
                </div>
                    :
                <div className="video-parent">
                    <IonImg className="image-thumbnail" src={content.thumbnail} 
                        style={{ height: content.heights[0] > 0 ? content.heights[0] : "100%" }} />
                    <IonIcon className="video-icon" icon={logoYoutube} />
                </div>
                }
            </div>
            
            {
                // video content description or title
                (content.title != "" || content.desc != "") && view != "video" ?
            <IonItem lines="none" onClick={showContent}>
                <IonLabel className="ion-text-wrap">
            {
                content.title != "" ?
                <IonText className="content-title">{content.title}<br/></IonText>
                :
            <div/>
            }

            {
                content.desc != "" ?
                <IonText className="content-desc">{content.desc}</IonText>
                :
            <div/>
            }
                </IonLabel>
            </IonItem>
                :
            <div/>
            }
            
            {
                /* action button */
                view != "video" ?
            <ActionComp content={content} />
                :
            <div/>
            }
            
            { /* like bar */ }
            <LikeBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
        </div>
    );
};
  
export default VidFileContent;